import { Box, Button, Card, CardContent, FormControl, FormControlLabel, Checkbox, Grid, MenuItem, Select, Typography } from '@mui/material';
import React, { useEffect,  useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { camelCaseString } from '../../../utils/format-utils';
import SendIcon from '@mui/icons-material/Send';
import { sendSecureMessage, sendSecureMessageCleanUp } from '../../../redux/securemessage/actions';
import ImageBanner from './ImageBanner';
import { InfoOutlined } from '@mui/icons-material';
import Label from '../type/Label';
import { getLanguageCookies } from '../../../utils/content-utils';

const topicArray = ['findCareLabel', 'schedulingLabel', 'medicalBenefitsLabel', 'prescriptionLabel', 'technicalLabel', 'GeneralQuestions'];
const maxCharacters = 300;
const SecureMessage = () => {
    const dispatch = useDispatch();
    const [memberList, setMemberList] = useState([]);
    const [topic, setTopic] = useState('');
    const [message, setMessage] = useState('');
    const [charsRemain, setCharsRemain] = useState(maxCharacters);
    const language = getLanguageCookies();

    const memberAccounts = useSelector(
        state => state?.memberAccounts?.memberAccountsDetails
    );
    // const loading = useSelector(state => state?.seureMessage.loading);
    // const errorForSecureMessage = useSelector(state => state?.seureMessage.error);
    const responseForSecureMessage = useSelector(state => state?.secureMessage.response);
    
    // const selectInputRef = useRef(null);

    const isButtonDisabled = topic === '' || message === '' || message.trim() === '';


    useEffect(() => {
        dispatch(sendSecureMessageCleanUp());
    }, []);
    useEffect(() => {
        if (memberAccounts?.self || memberAccounts?.dependents)
            memberAccounts?.self ?
                setMemberList([{ ...memberAccounts.self }, ...memberAccounts.dependents,]) :
                setMemberList([null, ...memberAccounts.dependents]);
    }, [memberAccounts]);

    const changeTopic = (event) => {
        setTopic(event.target.value);
    };
    const changeMemberList = (memberIndex) => {
        const updatedMembers = memberList.map((member, index) => memberIndex === index ? { ...member, includeMember: !member.includeMember } : member);
        setMemberList(updatedMembers);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        var reqMemerArray = [];
        if(message.trimEnd() != ''){       
            let messageString = '';
            if(memberList[0] != null){
                memberList.map(item => {
                    if(item.includeMember){
                        var reqObj = {
                            'subscriberId': item?.subscriberId,
                            'subscriberSuffix': item?.subscriberSuffix,
                            'firstName': item?.firstName,
                            'lastName': item?.lastName
                        };
                        reqMemerArray.push(reqObj);
                    }
                });
             messageString =  message.trimEnd();
            }else{
                messageString =  message.trimEnd();
            }        
            dispatch(sendSecureMessage(reqMemerArray, topic , messageString, localStorage.getItem('tenantHandle')));
            resetHandler();
        }
    };
    const resetHandler = ()=> {
        setMessage('');
        setTopic('');
        setCharsRemain(maxCharacters);
        if(memberList[0] != null){
            setMemberList(memberList.map((member)=> {
                if(member.includeMember){
                    member.includeMember = false;
                }
                return member;
            }));
       }
    };
    const setMessageForSM = (event)=> {
        let text = event.target.value;
        let numberOfCharacters;
        if(text.length > maxCharacters) {
            text = text.substring(0 , maxCharacters);
            numberOfCharacters = 0;
        }
        else {
            numberOfCharacters = maxCharacters - text.length;
        }
        setMessage(text);
        setCharsRemain(numberOfCharacters);
    };
    return (
        <>
            <ImageBanner title={<Label id='securemessage'/>}></ImageBanner>
            {responseForSecureMessage && <Card className='successCardForSm'>
                <InfoOutlined color='primary' />
                <CardContent className='successCardContent'>
                    <Typography variant='h6'><Label id="MessageAcknolgement" /></Typography>
                    <Typography varaint='body1'><Label id="ResponsetoRegisterdMail" /></Typography>
                </CardContent></Card>}
            <Box className='smcontainer emergency-call' component='form' onSubmit={handleSubmit}>
                {!responseForSecureMessage && <Typography variant='body1' className='emergency-text'>
                    <Label id="LifeThreateningEmergency" />
            </Typography>}

                <Card className='smCard'>
                    <Typography variant='h3' className='secure-message-title'><Label id="SendASecureMessage" /></Typography>
                    <CardContent className='smContent'>
                        <Box className='smLeftContent'>
                        <label className='smLabel topic-label'><Label id="Topic" /> <span className='mandatory-field' style={{color:'red'}}>*</span></label>
                            <FormControl className='smSelect'
                            >
                                <Select value={topic} onChange={changeTopic} displayEmpty>
                                    <MenuItem value=''><Label id="ChooseTopic"/></MenuItem>
                                    {topicArray.map((element, index) => (<MenuItem value={element} key={index}><Label id={element} /></MenuItem>))}
                                </Select>
                            </FormControl>
                            <Card className='smHelperText'>
                                <ul>
                                    <li>
                                        <Typography variant='body1'>
                                        <Label id="SelectTopicToEnsureYourMessageIsAttendedToRightAway"/>
                            </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='body1'>
                                        
                                        <Label id="SelectAName" />
                            </Typography>
                                    </li>
                                </ul>
                            </Card>


                        </Box>
                        <Box className='smRightContent'>
                            <Typography variant='subtitle1' className='choose-member-label'><Label id="ChooseMembersThatThisMessageIsAbout" />:</Typography>
                            {memberList[0] === null && <Typography variant='body1'>
                                No members found</Typography>}
                            <FormControl className='smRightCheckBox'>
                                {memberList[0]?.firstName && memberList.map((member, index) => {
                                    return <FormControlLabel key={index} control={<Checkbox color='primary' onClick={() => { changeMemberList(index); }}
                                        checked={member?.includeMember || false}

                                    />} label={<Typography variant='body1'>{camelCaseString(member?.firstName) + ' ' + camelCaseString(member?.lastName)}</Typography>}>
                                    </FormControlLabel>;
                                })}
                            </FormControl>

                        </Box>
                    </CardContent>
                    <FormControl className='smTextArea'>
                        <Typography>{charsRemain} <Label id="characterRemaining" /></Typography>
                        <textarea id='smTextAreaId' className='smMessageBox' required placeholder={language === 'es'? 'Escribe tu mensaje' : 'Type your message'} value={message} onChange={setMessageForSM}></textarea>
                        <label htmlFor='smTextAreaId'><Label id="message"/> <span className='mandatory-field' style={{color:'red'}}>*</span></label>
                    </FormControl>
                    <CardContent className='smActionArea'>
                        <Typography variant='body1'>*<Label id="responseToRegisteredEMail" /></Typography>
                        <Grid className='smBtnGroup'>
                            <Button variant='contained' className='clearBtn' id='sm-clear-btn' onClick={resetHandler}><Label id="clear" /></Button>
                           
                            <Button
        className={`sendBtn ${isButtonDisabled ? 'disabled' : ''}`}
        id="sm-send-btn"
        type="submit"
        disabled={isButtonDisabled}
      ><Label id="send" /> <SendIcon /></Button>
                           </Grid>
                    </CardContent>
                </Card>
            </Box>
        </>
    );
};

export default SecureMessage;
